import { abortNavigation, navigateTo } from '#imports'
import { authStore } from '~/store/auth'
import { useGeneralStore } from '~/store/GeneralStore'

export default defineNuxtRouteMiddleware((to, from) => {
  // ✅ 1. Permitir acceso a rutas públicas
  if (to.meta.public) return

  const { authenticated, data } = storeToRefs(authStore())
  const { setAuthenticated, signOut } = authStore()
  const { setContext } = useGeneralStore()

  const token = localStorage.getItem('accessToken')

  // 🛑 Si no hay token y va a /home, redirige al login
  if (!token && to?.name === 'home') {
    abortNavigation()
    
    return navigateTo('/login')
  }

  // 🔁 Si hay token y está en /login, redirige al home
  if (token && to?.name === 'login') {
    return navigateTo('/home')
  }

  // 🎯 Rutas con excepción de validación de menú/contexto
  const exceptionsRoute = [
    '/agenda/personal',
    '/agenda',
    '/agenda/label/:tag',
    '/agenda/filter/:filter',
    '/profile/settings/:tab',
    '/profile/cv',
    '/finance/my',
    '/rules/politicas',
    '/rules/manual',
    '/rules/licencia',
    '/links',
    '/contacto',
    '/politicas',
    '/incidents/my',
    '/cms/:category/',
    '/cms/:category/:slug',
    '/rooms',
    '/rooms/:room',
    '/rooms/:room/:channel',
    '/',
    '/login',
    '/forgotPassword',
    '/resetPassword/:token',
    '/logout',

    /* TODO: ESTOS PERMISOS DEBERIAN EXISTIR */
    '/admin/library/loans',
    '/admin/library/borrow',
    '/admin/library/searcher',
    '/home',
    '/chat',
    '/circulares/:category/:slug',
  ]

  // 🔁 Parametros con nombre
  const noRouteParams = ref(to.fullPath)

  Object.entries(to.params).forEach(([key, value]) => {
    noRouteParams.value = noRouteParams.value.replace(value, `:${key}`)
  })

  // 🔍 Si no es excepción, verificar permisos por contexto
  if (!exceptionsRoute.includes(noRouteParams.value)) {
    const originalPath = to.params.id
      ? to.matched[0].path.split('/')
        .filter(path => !path.includes(':') && path !== '')
        .join('/')
      : to.fullPath.slice(1)

    const params = to.params.id ? to.params : {}
    const auth = data.value

    if (auth) {
      const currentContext = auth.context?.[params.id || 1]
      const validRoute = currentContext?.menu?.includes(originalPath) ?? false

      if (!validRoute) return navigateTo('/')
    } else {
      return navigateTo('/')
    }
  }

  // ⏳ Establecer el contexto activo
  setContext(to.params.id || 0)

  // 🔐 Verificación de autenticación
  if (token && token !== 'null') {
    setAuthenticated(true)
  } else if (authenticated.value) {
    setAuthenticated(false)
    signOut()
  }

  // 🔒 Si no hay token y no está en login, redirigir
  if (!token && to?.name !== 'login') {
    abortNavigation()
    
    return navigateTo('/login')
  }
})
